'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	formattedNodeTitle = require('@mindmup/mapjs-core/src/content/formatted-node-title'),
	_ = require('underscore');
module.exports = function WriterModel(collaborationModel, mapModel, attribName) {
	let traversalIndices = {},
		inputEnabled = false,
		notes = {};
	const self = observable(this),
		indexFor = function (nodeId) { /*TODO, check where used if at all - we're probably using fixed ordering */
			return traversalIndices[nodeId];
		},
		findContentIdea = function (id) {
			const aggregate = collaborationModel.getActiveContent();
			return (aggregate.id === id) ? aggregate : aggregate.findSubIdeaById(id);
		},
		getTitleForIdea = function (idea) {
			return formattedNodeTitle(idea && idea.title, 40);
		},
		getTitle = function (nodeId) {
			const idea = findContentIdea(nodeId);
			return getTitleForIdea(idea);
		},
		editNote = function (note) {
			if (note) {
				self.setActiveNodeId(note.nodeId);
				self.dispatchEvent('noteEditRequested', note);
			}
			return !!note;
		},
		sendContext = function () {
			const hasSelection = !!(mapModel.getIdea() && notes[mapModel.getSelectedNodeId()]);
			self.dispatchEvent('writerContext', {
				isEnabled: inputEnabled,
				hasSelection: hasSelection /* hasNote */
			});
		},
		activateNote = function (nodeId) {
			const noteInfo = notes[nodeId];
			self.dispatchEvent('activeNodeChanged', noteInfo && nodeId);
			sendContext();
		},
		convertFromHtml = function (htmlContent) {
			return htmlContent && htmlContent
				.replace(/\n+/g, ' ')
				.replace(/<\/p><p>/gi, '\n\n')
				.replace(/<\/?p>/gi, '\n\n')
				.replace(/<\/div><div>/gi, '\n\n')
				.replace(/<\/?div>/gi, '\n\n')
				.replace(/<br\/?>/gi, '\n\n')
				.replace(/<\/li><\/[uo]l>/gi, '\n\n')
				.replace(/<\/?[uo]l>/gi, '\n\n')
				.replace(/<\/li>/gi, '\n\n')
				.replace(/<li>/gi, '* ')
				.replace(/<\/?i>/gi, '_')
				.replace(/<\/?b>/gi, '**')
				.replace(/<\/h[0-9]>/gi, '\n\n')
				.replace(/<h1>/gi, '\n\n# ')
				.replace(/<h2>/gi, '\n\n## ')
				.replace(/<h3>/gi, '\n\n### ')
				.replace(/<h4>/gi, '\n\n#### ')
				.replace(/<h[0-9]>/gi, '\n\n')
				.replace(/<a[^>]*href="([^"]*)"[^>]*>([^<]*)<\/a>/gi, '[$2]($1)')
				.replace(/<a[^>]*href='([^']*)'[^>]*>([^<]*)<\/a>/gi, '[$2]($1)')
				.replace(/<a[^>]*href=([^"'][^ ]*) [^>]*>([^<]*)<\/a>/gi, '[$2]($1)')
				.replace(/<[^>]*>/g, '')
				.replace(/\n\n+/g, '\n\n')
				.trim();
		},
		collectNewNotes = function (activeContent) {
			let index = 1;
			const result = {};
			traversalIndices = {};
			activeContent.traverse(function (idea) {
				traversalIndices[idea.id] = index++; //eslint-disable-line no-plusplus
				if (idea.attr && idea.attr[attribName]) {
					result[idea.id] = _.extend({}, idea.attr[attribName], {nodeId: idea.id, title: getTitleForIdea(idea), index: indexFor(idea.id)});
				}
			});
			return result;
		};

	self.setText = function (nodeId, text) {
		const isTempNote = notes[nodeId] && notes[nodeId].isTemp;
		let note,
			removeTempNote;
		if (text) {
			note = collaborationModel.getActiveContent().getAttrById(nodeId, attribName) || {  index: indexFor(nodeId) };
			note.text = text;
		} else {
			note = false;
		}
		removeTempNote = !note && isTempNote;
		if (!removeTempNote && !collaborationModel.getActiveContent().updateAttr(nodeId, attribName, note)) {
			//save failed, temp note should be removed
			removeTempNote = isTempNote;
		}
		if (removeTempNote) {
			delete notes[nodeId];
			self.dispatchEvent('noteRemoved', nodeId);
		}
	};
	self.editNoteForSelectedNode = function () {
		self.editNoteForNodeId(mapModel.getSelectedNodeId());
	};
	self.editNoteForNodeId = function (nodeId) {
		if (!mapModel.isEditingEnabled()) {
			return;
		}
		if (!notes[nodeId]) {
			notes[nodeId] = {index: indexFor(nodeId), nodeId: nodeId, title: getTitle(nodeId), isTemp: true };
		}
		return editNote(notes[nodeId]);
	};
	self.removeSelected = function () {
		self.setText(mapModel.getSelectedNodeId());
	};
	self.removeNoteForNodeId = function (nodeId) {
		if (!mapModel.isEditingEnabled()) {
			return;
		}
		self.setText(nodeId);
	};
	self.setActiveNodeId = function (nodeId) {
		mapModel.centerOnNode(nodeId);
	};

	collaborationModel.addListener(function (activeContent) {
		const oldKeys = _.keys(notes),
			newNotes = collectNewNotes(activeContent),
			newKeys = _.keys(newNotes);

		let contextChanged = false;

		_.difference(oldKeys, newKeys).forEach(function (removedNodeId) {
			if (notes[removedNodeId].isTemp) {
				newNotes[removedNodeId] = notes[removedNodeId];
				return;
			}
			self.dispatchEvent('noteRemoved', removedNodeId);
			contextChanged = true;
		});
		_.difference(newKeys, oldKeys).forEach(function (nodeId) {
			self.dispatchEvent('noteAdded', newNotes[nodeId]);
			contextChanged = true;
		});
		_.intersection(newKeys, oldKeys).forEach(function (nodeId) {
			const newNote = newNotes[nodeId];
			if (!notes[nodeId].text) {
				self.dispatchEvent('noteAdded', newNote);
				contextChanged = true;
			} else {
				if (notes[nodeId].text !== newNote.text || notes[nodeId].title !== newNote.title) {
					self.dispatchEvent('noteChanged', newNote);
				}
				if (notes[nodeId].index !== newNote.index) {
					self.dispatchEvent('noteMoved', newNote);
					contextChanged = true;
				}
			}
		});
		notes = newNotes;
		if (contextChanged) {
			sendContext();
		}

	});
	self.requestContextMenu = function (x, y) {
		self.dispatchEvent('contextMenuRequested', mapModel.getSelectedNodeId(), x, y, true);
		return true;
	};
	self.setInputEnabled = function (enabled) {
		inputEnabled = enabled;
		sendContext();
	};
	self.toggleActiveNoteFolded = function () {
		self.dispatchEvent('noteToggleFoldRequested', mapModel.getSelectedNodeId());
	};
	self.foldInactiveNotes = function () {
		self.dispatchEvent('foldInactiveNotesRequested');
	};
	self.toggleNoteFolded = function (nodeId) {
		self.dispatchEvent('noteToggleFoldRequested', nodeId);
	};
	self.canImportFromAttachment = function (nodeId) {
		const attachment = collaborationModel.getActiveContent().getAttrById(nodeId, 'attachment');
		return attachment && attachment.contentType === 'text/html' && !attachment.dataUriEncoded && attachment.content;
	};
	self.importFromAttachment = function (nodeId) {
		const attachment = collaborationModel.getActiveContent().getAttrById(nodeId, 'attachment'),
			converted = self.canImportFromAttachment(nodeId) && convertFromHtml(attachment.content);
		if (!converted) {
			return false;
		}

		collaborationModel.getActiveContent().batch(function () {
			collaborationModel.getActiveContent().updateAttr(nodeId, 'attachment', false);
			collaborationModel.getActiveContent().updateAttr(nodeId,  attribName, {text: converted});
		});
		return true;
	};
	mapModel.addEventListener('nodeSelectionChanged', function (nodeId, isSelected) { /* todo: check event name */
		if (isSelected && inputEnabled) {
			activateNote(nodeId);
		}
	});
	mapModel.addEventListener('decorationActionRequested', function (nodeId, decorationName) {
		if (decorationName === 'note') {
			if (mapModel.isEditingEnabled()) {
				self.editNoteForNodeId(nodeId);
			} else {
				activateNote(nodeId);
			}

		}
	});
};
